import React, { useEffect, useState } from 'react';
import { MobileHeaderContainer } from './MobileHeader.css';

import Moment from 'moment';

const MobileHeader = () => {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessage(Moment().format('YYYY-MM-DD (ddd) h:mm:ss'));
    }, 250);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MobileHeaderContainer>
      {/* <img src={ci} alt="ci" /> */}
      <div className="header-title">가스안전 모니터링 시스템</div>
      <h6>TKG휴켐스 독성가스 감지시스템</h6>
      <div className="header-clock">{message}</div>
    </MobileHeaderContainer>
  );
};

export default MobileHeader;
